import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import { Checkbox as CoreCheckbox } from '@vds-core/inputs';
import { Body, BodyConfig, TypographyConfig } from '@vds/typography';
import CheckboxIcon from './CheckboxIcon';
import { calculateSpacing } from '@vds/theme';
var propTypes = {
  /**
   * If provided, this will render as bold text inside the label of the checkbox. When using this prop with children, this will be the first line of text followed by children.
   */
  label: PropTypes.string
};

var Checkbox = function Checkbox(props) {
  var checkboxMarginRight = calculateSpacing('3X');
  var errorMargin = calculateSpacing('2X');
  var marginBottom = calculateRem(0);
  var maxWidth = calculateRem(596);
  return /*#__PURE__*/React.createElement(CoreCheckbox, _extends({}, props, {
    focusState: true,
    typescale: TypographyConfig.getTypescale(),
    bodyConfig: BodyConfig,
    CheckboxIcon: CheckboxIcon,
    checkboxMarginRight: checkboxMarginRight,
    errorMargin: errorMargin,
    marginBottom: marginBottom,
    maxWidth: maxWidth,
    hitAreaLabelMargin: true,
    Body: Body
  }));
};

Checkbox.propTypes = propTypes;
export default Checkbox;